import React, { useEffect, useState } from "react";

import { FormResources } from "../types/formData";
import { getFailedChecks } from "../utils/vehicleCheckHelpers";
import { useValuationManagerContext } from "../ValuationManagerContext";

interface Props {
  formResources: FormResources;
}

export const ExcludedFromValuationPage = ({ formResources }: Props) => {
  const { appInput, vehicleDetails } = useValuationManagerContext();

  const [excludedReasons, setExcludedReasons] = useState<string[]>([]);

  const link = appInput?.qualificationId
    ? `https://www.carsanet.co.uk/qualifications/edit/${appInput.qualificationId}/px_basic_details`
    : undefined;

  useEffect(() => {
    if (vehicleDetails) {
      const excludedReasons = getFailedChecks(vehicleDetails.checks.checks);
      setExcludedReasons(excludedReasons);
    }
  }, [vehicleDetails, setExcludedReasons]);

  return (
    <div className="panel panel-default">
      <div className="panel-heading">{formResources.excluded.title}</div>
      <div className="panel-body">
        <p>{"We can't give a valuation because this vehicle is recorded as:"}</p>
        <ul>
          {excludedReasons.map((reason) => (
            <li key={reason}>{reason}</li>
          ))}
        </ul>
        {link ? (
          <div className="panel-body">
            <a href={link} rel="noopener noreferrer">
              <button
                className="btn btn-success"
                data-testid="redirect-button"
                type="button"
              >
                Take me back to Carsanet
              </button>
            </a>
          </div>
        ) : (
          <p>{"Please use the browser back button to navigate back to Carsanet"}</p>
        )}
      </div>
    </div>
  );
};
